import React, { useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

import { useQuery } from '../../hooks/useQuery'
import { getCompanyAssetsCategories, getAssetsOwnerships, getCompanyEmployeesAll, getPlaces } from '../../api'
import { setOptions } from '../../store/asset/actions'

import MainLayout from '../../components/Core/MainLayout'
import AppNavbar from '../../components/Core/AppNavbar'
import Assets from '../../components/Assets/Assets'
import AssetForm from '../../components/Assets/AssetForm'
import AssetDetails from '../../components/Assets/AssetDetails'
import PrintLabelModal from '../../components/Assets/PrintLabelModal'
import AssetsLocations from '../../components/Assets/Locations'
import AssetRentals from '../../components/Assets/AssetRentals'
import Maintenance from '../../components/Assets/Maintenance'
import MaintenanceRecordForm from '../../components/Assets/MaintenanceRecordForm'
import MaintenanceRecordDetails from '../../components/Assets/MaintenanceRecordDetails'

const AssetsScreen = () => {

  const { t } = useTranslation()
  const { id: companyId } = useParams()
  const { tab: activeTab } = useQuery(['tab:overview'])
  const history = useHistory()
  const dispatch = useDispatch()

  const options = [{
    title: t('Overview'),
    key: 'overview',
  }, {
    title: t('Assets'),
    key: 'assets',
  }, {
    title: t('Locations'),
    key: 'locations',
  }, {
    title: t('Rentals'),
    key: 'rentals',
  }, {
    title: t('Maintenance'),
    key: 'maintenance',
  }]

  useEffect(() => {
    if (companyId) {
      getData(companyId)
    }
  }, [companyId])

  const getData = async (companyId) => {
    const [categoriesRes, ownershipsRes, employeesRes, placesRes] = await Promise.all([
      getCompanyAssetsCategories(companyId),
      getAssetsOwnerships(companyId),
      getCompanyEmployeesAll(companyId),
      getPlaces(companyId),
    ])
    if (Array.isArray(categoriesRes) && Array.isArray(ownershipsRes) && Array.isArray(employeesRes?.users) && Array.isArray(placesRes)) {
      dispatch(setOptions({
        categories: categoriesRes,
        ownerships: ownershipsRes,
        employees: employeesRes.users,
        places: placesRes,
      }))
    }
  }

  const handleSelectTab = key => {
    history.push({search: `?tab=${key}`})
  }

  return (
    <MainLayout layoutClassName={styles.layout} screenClassName={styles.screen}>
      <div className={styles.navBar}>
        <AppNavbar
          options={options}
          selected={activeTab}
          onSelect={handleSelectTab} />
      </div>
      <div className={styles.content}>
        {
          (tab => {
            switch (true) {
              case tab === 'assets':
                return (
                  <Assets companyId={companyId} />
                )
              case tab === 'locations':
                return (
                  <AssetsLocations companyId={companyId} />
                )
              case tab === 'rentals':
                return (
                  <AssetRentals companyId={companyId} />
                )
              case tab === 'maintenance':
                return (
                  <Maintenance companyId={companyId} />
                )
              case /^\d+$/.test(tab):
                return (
                  <AssetDetails companyId={companyId} assetId={tab} />
                )
              default:
                return null
            }
          })(activeTab)
        }
      </div>
      <AssetForm companyId={companyId} />
      <PrintLabelModal />
      <MaintenanceRecordForm companyId={companyId} />
      <MaintenanceRecordDetails />
    </MainLayout>
  )
}

export default AssetsScreen
